import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
import {
  addOMPtStatusAsync,
  deleteOMPtStatusAsync,
  editOMPtStatusAsync,
  getOMPtStatusAsync,
} from "../../../store/services/orderManagementService";
const PtStatus = () => {
  const dispatch = useDispatch();
  const {
    getOMPtStatusStatus,
    getOMPtStatusError,
    getOMPtStatusData,
    addOMPtStatusStatus,
    addOMPtStatusData,
    addOMPtStatusError,

    editOMPtStatusStatus,
    editOMPtStatusError,
    editOMPtStatusData,

    deleteOMPtStatusData,
    deleteOMPtStatusStatus,
    deleteOMPtStatusError,
  } = useSelector((state) => state.om);

  useEffect(() => {
    dispatch(getOMPtStatusAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMPtStatusData?.length
    ? getOMPtStatusData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedPtStatus, setSelectedPtStatus] = useState();
  const [addPtStatusMode, setAddPtStatusMode] = useState(false);
  const [addPtStatusData, setAddPtStatusData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedPtStatus", selectedPtStatus);
  // console.log("editData", editData);
  useEffect(() => {
    if (addOMPtStatusStatus === asyncStatus.SUCCEEDED) {
      setAddPtStatusMode(false);
      setSaveDisabled(true);
      setAddPtStatusData();
    }
  }, [, addOMPtStatusStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteOMPtStatusAsync(selectedPtStatus?.pt_status_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteOMPtStatusStatus === asyncStatus.SUCCEEDED || deleteOMPtStatusStatus === asyncStatus.ERROR ) {
      setOpen(false);
      setSelectedPtStatus();
    }
  }, [, deleteOMPtStatusStatus]);
  useEffect(() => {
    if (editOMPtStatusStatus === asyncStatus.SUCCEEDED) {
      setSelectedPtStatus();
      setEditMode(false);
      setEditData()
    }
  }, [, editOMPtStatusStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this pick ticket status?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Pick Ticket Status"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Pick Ticket Status
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddPtStatusMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addPtStatusMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addPtStatusMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddPtStatusMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addPtStatusMode || !selectedPtStatus}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMPtStatusStatus === asyncStatus.LOADING ||
                  editOMPtStatusStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addPtStatusData) {
                    dispatch(addOMPtStatusAsync(addPtStatusData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedPtStatus, ...editData };
                    delete a.id;
                    dispatch(editOMPtStatusAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "pt_status_id", headerName: "ID", flex: true },
                  { field: "pt_status_name", headerName: "Pick Ticket Status", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedPtStatus(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMPtStatusStatus === asyncStatus.IDLE ||
                  getOMPtStatusStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addPtStatusMode ? (
              <InputWithBtnLayoutComp
              error={addOMPtStatusError}
                inputArray={[
                  {
                    label: "Pick Ticket Status:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddPtStatusData({
                            ...addPtStatusData,
                            pt_status_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddPtStatusData({
                            ...addPtStatusData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedPtStatus ? (
              <InputWithBtnLayoutComp
              error={editOMPtStatusError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedPtStatus?.pt_status_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "Pick Ticket Status:",
                    comp: (
                      <InputComp
                        key={selectedPtStatus?.pt_status_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            pt_status_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedPtStatus?.pt_status_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={selectedPtStatus?.is_active|| editData?.is_active}
                        disabled={!editMode}
                        // defaultValue={selectedPtStatus?.is_active || editData?.is_active}
                        defaultChecked={selectedPtStatus?.is_active || editData?.is_active}
                        // checked={selectedPtStatus?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (<Stack>
              <Typography>Select any pick ticket status</Typography>
              <Typography color={"red"} fontSize={12}>{getOMPtStatusError}</Typography>
            </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedPtStatus(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedPtStatus(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default PtStatus;
